// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Iq_e","content":"styles_content__1JeuU","selectAll":"styles_selectAll__uLweZ"};